import Model from './model.js'
import Deal from './deal.js'
import Contact from './contact.js'
import Company from './company.js'
import moment from 'moment'
import humanizeDuration from 'humanize-duration'

export default class Event extends Model {
	static _routeKey = 'event'
	static _attributes = {
		title: '',
		description: '',
		start_date: function (model) {
			// console.log('model', model)
			if (model != null && model.starts_at != null) {
				return moment(model.starts_at).format('DD/MM/YYYY')
			}
			return null
		},
		end_date: function (model) {
			if (model != null && model.ends_at != null) {
				return moment(model.ends_at).format('DD/MM/YYYY')
			}
			return null
		},
		start_time: function (model) {
			if (model != null && model.starts_at != null) {
				return moment(model.starts_at).format('HH:mm')
			}
			return null
		},
		end_time: function (model) {
			if (model != null && model.ends_at != null) {
				return moment(model.ends_at).format('HH:mm')
			}
			return null
		},
		duration: null,
		completed_at: null,
	}

	// tail = {
	//     duration: () => ['duration', this.duration != null ? this.durationHuman() : null],
	//     starts_at: () => ['due', this.starts_at != null ? this.startHM() : null],
	//     ends_at: () => ['ends at', this.ends_at != null ? this.endHM() : null],
	//     completed_at: () => ['completed at', this.vue.$help.formatDateTime(this.completed_at, { date: true, time: true }), ''],
	//     belongs_id: () => ['Linked deal', this.belongs_id],
	//     createdDescription: () => '"' + this.title + '" was created',
	//     extra_keys: {
	//         belongs_id: () => (this.belongs_id ? ['Linked deal', this.belongs_id] : null),
	//     },
	// }

	_tailIgnore = [
		'_tailIgnore',
		'tailIgnore',
		'tail',
		'vue',
		'created_at',
		'updated_at',
		'id',
		'created_by_user_id',
		'belongs_type',
		'$help',
		'$log',
		'publishedStates',
	]

	publishedStates = ['draft', 'sent']

	_constructor() {
		if (this.belongs != null) {
			switch (parseInt(this.belongs_type)) {
				case 2:
					this.company = new Company(this.belongs)
					break;
				case 102:
					this.contact = new Contact(this.belongs)
					break
				case 103:
					this.contact = new Contact(this.belongs.contact, {
						vue: this.vue,
					})
					this.deal = new Deal(this.belongs, {
						vue: this.vue,
					})
					break
			}
		}
	}

	canPublish() {
		return this.published_at == null
	}

	canComplete() {
		return this.completed_at == null
	}

	_type() {
		return parseInt(this.appointment) == 0 ? 'task' : 'appointment'
	}

	label() {
		return this.appointment == 0 ? 'task' : 'event'
	}

	edit(type = 0) {
		this.vue.$event.$emit('modal-open', {
			view: 'Task',
			editingModel: this,
			modelId: this.belongs_id,
			modelType: this.belongs_type,
			options: {
				task: this.id != null ? this.appointment : type,
			},
		})
		// this.vue.$event.$emit("timeline-edit", {
		// 	type: this._type(),
		// 	data: this
		// })
	}

	view() {
		this.vue.$event.$emit('modal-open', {
			view: 'TaskView',
			editingModel: this,
		})
	}

	calendarLink(view = 'day') {
		return {
			name: 'calendar',
			query: {
				event_id: this.id,
				date: moment(this.starts_at).format('YYYY-MM-DD'),
				view: view,
			},
		}
	}

	post(timelineId) {
		this.vue.$axios.post('/history/' + timelineId + '/publish').then((res) => {
			this.vue.$event.$emit('timeline-published')
		})
	}

	destroy(emit = 'timeline-deleted') {
		this.vue.$event.$emit('modal-open', {
			view: 'Confirm',
			options: {
				action: '/event/' + this.id,
				message: 'Are you sure you want to delete this ' + this.label() + '?',
				button: 'Delete',
				method: 'DELETE',
				head: 'Delete ' + this.label(),
			},
		})

		// this.vue.$axios.delete('/'+this._type()+'/'+this.id)
		//     .then(res => {
		//         this.vue.$event.$emit(emit)
		//     })
	}

	complete(emit = 'timeline-completed') {
		this.completed_at = moment().format()

		return Promise.resolve(
			this.vue.$axios.post('/actions/calendar-complete/' + this.id).then((res) => {
				this.vue.$event.$emit(emit)
			}),
		)
	}

	extend(dateString = '1 day', emit = 'timeline-completed') {
		return Promise.resolve(
			this.vue.$axios
				.post('/actions/task-extend/' + this.id, {
					date_string: dateString,
				})
				.then((res) => {
					this.vue.$event.$emit(emit)
				}),
		)
	}

	clearComplete(emit = 'timeline-completed') {
		this.completed_at = null
		return Promise.resolve(
			this.vue.$axios
				.post('/actions/calendar-complete/' + this.id, {
					clear: true,
				})
				.then((res) => {
					this.vue.$event.$emit(emit)
				}),
		)
	}

	startHM(date = true, time = true) {
		return this.vue.$help.formatDateTime(this.starts_at, {
			date: date,
			time: time,
		})
	}

	endHM(date = true, time = true) {
		if (this.ends_at == null) {
			return null
		}

		return this.vue.$help.formatDateTime(this.ends_at, {
			date: date,
			time: time,
		})
	}

	durationHM() {
		let h = Math.floor(this.duration / 60)
		let m = this.duration % 60

		return (h > 0 ? h + ' hour' + (h > 1 ? 's' : '') : '') + (m != '00' ? (h > 0 ? ' ' : '') + m + ' minutes' : '')
	}

	durationHuman() {
		let diff = this.virtual_ends_at == undefined ? this.duration * 60000 : moment(this.virtual_ends_at).diff(moment(this.starts_at))

		return humanizeDuration(diff, {
			largest: 2,
			round: true,
			units: ['y', 'mo', 'w', 'd', 'h', 'm'],
			delimiter: ' ',
		})

		// let duration = moment.duration(moment(this.ends_at).diff(moment(this.starts_at)))

		// if (this.ends_at == null) {
		//     return this.durationHM()
		//     // duration = moment.duration(this.duration, 'minutes')
		// }

		// return duration.humanize().replace('a ', '1 ')
	}

	to() {
		let name = parseInt(this.belongs_type) == 102 ? 'contact' : 'deal'

		return {
			name: name,
			params: {
				id: this.belongs_id,
			},
			query: {
				goto: 'task:' + this.id,
			},
		}
	}

	level(only = null) {
		if (this.belongs_type !== undefined && this.belongs != null) {
			let title = ''
			let link = ''
			let data = null

			switch (true) {
				case this.vue.$help.idName(this.belongs_type) == 'deal':
					link = '/deal/' + this.belongs_id

					data = new Deal(this.belongs)

					title = data.getName()
					break

				case this.vue.$help.idName(this.belongs_type) == 'contact' && only == null:
					data = new Contact(this.belongs)

					title = data.fullName()

					link = '/contact/' + this.belongs_id
					break
				default:
					return false
			}

			return {
				model: this.vue.$help.idName(this.belongs_type),
				data: data,
				title: title,
				link: link,
			}
		}

		return false
	}

	links() {
		let links = []

		switch (parseInt(this.belongs_type)) {
			case 2:
				console.log(this.belongs);
				
				links.push({
					type: 'company',
					icon: 'IconUserCircle',
					data: new Company(this.belongs),
				})
			break;
			case 103:
				links.push({
					type: 'contact',
					icon: 'IconUserCircle',
					data: new Contact(this.belongs.contact),
				})

				links.push({
					type: 'deal',
					icon: 'IconDealGrey',
					data: new Deal(this.belongs),
				})
				break
			case 102:
				links.push({
					type: 'contact',
					icon: 'IconUserCircle',
					data: new Contact(this.belongs),
				})
				break
		}

		return links
	}

	dueIn(human = false) {
		let diff = moment(this.starts_at).diff(moment())
		let after = ''

		if (diff < 0) {
			after = ' ago'
		}

		return (
			humanizeDuration(diff, {
				largest: 2,
				round: true,
				units: ['y', 'mo', 'w', 'd', 'h', 'm'],
			}) + after
		)

		// let duration = moment.duration(moment(this.starts_at).diff(new Date()))
		// let hours = parseInt(duration.asHours())
		// let minutes = parseInt(duration.asMinutes()) % 60

		// if (human) {
		//     let diff = moment(this.starts_at).diff(moment(), 'hours')

		//     if (diff <= 24) {
		//         return moment().format('DD') == moment(this.starts_at).format('DD') ? 'Today' : 'Tomorrow'
		//     }

		//     return this.vue.$help.capitalizeFirstLetter(moment().to(moment(this.starts_at)))
		// }

		// return hours == 0 ? minutes + 'm' : hours + 'h ' + minutes + 'm'
	}

	time(replace = false) {
		return moment(this.starts_at).format('HH:mm')
		// .replace(replace ? ':00' : '', '')
	}

	timeTo() {
		if (this.statusString() == 'Completed' || this.statusString() == 'Done') {
			return
		}

		return moment().to(this.starts_at)
	}

	dropped(date, time = false) {
		// console.log(date.format(), this.starts_at)

		if (!time) {
			this.starts_at = moment(date).format('YYYY-MM-DD') + ' ' + moment(this.starts_at).format('HH:mm')
		} else {
			this.starts_at = moment(date).format('YYYY-MM-DD HH:mm')
		}

		console.log(this.starts_at)

		return this.vue.$axios.post('/actions/calendar-date-change/' + this.id, {
			starts_at: this.starts_at,
		})
	}

	statusString() {
		return this.status

		if (this.appointment == 1) {
			return this.status
		}

		switch (this.status) {
			case 'Scheduled':
				return 'Planned'
				break
		}
	}

	statusIconName() {
		switch (this.status) {
			case 'Ended':
			case 'Done':
				return 'IconEventDone'
				break
			case 'Active':
				return 'IconEventActive'
				break
			case 'Planned':
			case 'Scheduled':
				return 'IconEventScheduled'
				break
			case 'Cancelled':
				return 'IconEventCancelled'
				break
			case 'Overdue':
				return 'IconAttentionCircle'
				break
		}
	}

	eventIcon() {
		if (this.appointment == 0) {
			return this.published_at == null ? 'IconTaskDraftCircle' : 'IconTaskCircle'
		} else {
			return this.published_at == null ? 'IconAppointmentDraftCircle' : 'IconAppointmentCircle'
		}
	}

	statusClass(type = 'bg') {
		switch (this.statusString().toLowerCase()) {
			case 'ended':
			case 'done':
			case 'completed':
				return type + '-green-600'
				break
			case 'active':
				return type + '-purple-500'
				break
			case 'planned':
			case 'scheduled':
				return type + '-grey-900'
				break
			case 'cancelled':
			case 'overdue':
				return type + '-red-700'
				break
		}
	}
}
